import settings from 'settings';

export const getCookie = (name) => {
  const { COOKIE_STORAGE } = settings;
  const match = `${COOKIE_STORAGE.prefix}${name}=`;
  const cookieList = document.cookie.split(';');

  for (let i = 0; i < cookieList.length; i++) {
    let keyValue = cookieList[i];
    while (keyValue.charAt(0) === ' ') {
      keyValue = keyValue.substring(1);
    }
    if (keyValue.indexOf(match) === 0) {
      return keyValue.substring(match.length, keyValue.length);
    }
  }
  return null;
};

export const setCookie = (name, value, expireDays = 0) => {
  const { COOKIE_STORAGE } = settings;
  if (expireDays > 0) {
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${expiryDate.toUTCString()}`;
    document.cookie = `${COOKIE_STORAGE.prefix}${name}=${value};${expires};path=${COOKIE_STORAGE.path}${COOKIE_STORAGE.secure ? ';secure' : ''}`;
  }
  else {
    document.cookie = `${COOKIE_STORAGE.prefix}${name}=${value};path=${COOKIE_STORAGE.path}${COOKIE_STORAGE.secure ? ';secure' : ''}`;
  }
};

export const removeCookie = (name) => {
  const { COOKIE_STORAGE } = settings;
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
  document.cookie = `${COOKIE_STORAGE.prefix}${name}=;${expires};path=${COOKIE_STORAGE.path}${COOKIE_STORAGE.secure ? ';secure' : ''}`;
};
